import { Alert, Box, Button } from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import useBoolean from "hooks/useBoolean";
import { useEffect, useState } from "react";
import { FormattedMessage as T, useIntl } from "react-intl";
import translateError from "utils/translateError";
import { DualListItem } from ".";
import DualListSelectorSearchable, {
  DualListSelectorSearchableProps,
} from "./DualListSelectorSearchable";
import { makeStyles } from "helpers/StyleHelper";

type DualListSelectorSearchableFormProps = {
  onClean?: () => void;
  onSubmit: () => Promise<any>;
  onDirty?: () => void;
} & DualListSelectorSearchableProps;

const useStyles = makeStyles((theme: Theme) => ({
  feedback: {
    width: "100%",
    margin: "20px 0 20px 0",
  },
}));

const DualListSelectorSearchableForm = ({
  setSearchTerm,
  options,
  selectedOptions,
  readonly,
  isFetching,
  index,
  onClean,
  onSubmit,
  onChange,
  onDirty,
}: DualListSelectorSearchableFormProps) => {
  const styles = useStyles(useTheme());
  const { formatMessage: t } = useIntl();
  const [error, setError] = useState<string | null>(null);
  const [submitting, submittingActions] = useBoolean(false);
  const [dirty, dirtyActions] = useBoolean(false);

  useEffect(() => {
    if (dirty && onDirty) onDirty();
  }, [dirty, onDirty]);

  const onSubmitForm = () => {
    submittingActions.setTrue();
    setError(null);
    return onSubmit()
      .then(() => {
        submittingActions.setFalse();
        dirtyActions.setFalse();
      })
      .catch((err: any) => {
        console.log(err);
        setError(translateError(err, t));
        submittingActions.setFalse();
      });
  };

  const onChangeForm = (selected: DualListItem[]) => {
    dirtyActions.setTrue();
    onChange(selected);
  };

  const onCleanForm = () => {
    dirtyActions.setFalse();
    onClean && onClean();
  };

  return (
    <>
      <DualListSelectorSearchable
        setSearchTerm={setSearchTerm}
        options={options}
        selectedOptions={selectedOptions}
        onChange={onChangeForm}
        isFetching={isFetching}
        readonly={readonly}
        index={index}
      />

      {error && (
        <Alert sx={styles.feedback} severity="error">
          {error}
        </Alert>
      )}
      {!readonly && (
        <Box display="flex" width={1} mt={1} justifyContent="flex-end">
          <Button disabled={submitting || !dirty} onClick={onCleanForm}>
            <T id="cancelButton" />
          </Button>

          <Box ml={2} />

          <Button
            onClick={onSubmitForm}
            color="primary"
            disabled={submitting || !dirty}
          >
            <T id="saveButton" />
          </Button>
        </Box>
      )}
    </>
  );
};

export default DualListSelectorSearchableForm;
